// extracted by mini-css-extract-plugin
export default {"activity":"Activity_activity__8kkOJ","offset":"Activity_offset__U1bpc"};